<template>
    <div class="blogger-articles-container">
      <v-row dense class="blogger-articles-row">
        <v-col
          v-for="(item, index) in articlesList"
          :key="item.title"
          cols="12" md="3"
          class="blog-col">
            <v-card width="200" height="270" class="mx-auto blogger-card" @click="toBlogContent(item)">
                <v-list-item>
                    <v-list-item-avatar color="#C5E1A5" size="24"><b class="avatar-text">{{ index | cookAvatar }}</b></v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="blog-title"  v-bind="attrs" v-on="on">{{ item.title | cookTitle }}</span>
                                </template>
                                <span>{{ item.title }}</span>
                            </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle><span class="blog-subtitle">{{ item.date }}</span></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-img :src="index | cookImg" height="160" contain></v-img>
                <v-list-item-action  class="blogger-card-action">
                    <v-row style="margin-left:10px">
                        <v-btn icon shaped small tile class="blogger-card-btn" v-for="tag in item.tags" :key="tag.name">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-avatar size="20" dark><v-img sizes="20" contain :src="tag.icon | cookTag" v-bind="attrs" v-on="on"></v-img></v-avatar>
                                </template>
                                <span>{{ tag.name }}</span>
                            </v-tooltip>
                        </v-btn>
                    </v-row>
                </v-list-item-action>
            </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" width="20%" color="#A5D6A7">
        <v-card>
            <v-card-title class="headline">输入查看密码?</v-card-title>
            <v-text-field type="password" color="success" v-model="inputCode" label="密码" @keyup.enter="showSercetArticle"></v-text-field>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                text
                @click="dialog = false"
            >
                取消
            </v-btn>

            <v-btn
                color="green darken-1"
                text
                @click="showSercetArticle"
            >
                确认
            </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" color="error" top timeout="2000"> 密码错误！ </v-snackbar>
      <v-pagination
        dark
        v-model="page"
        :length="length"
        :total-visible="totalVisible"
        ></v-pagination>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import CONFIG from '@/config/config.js';
export default {
    filters: {
        cookAvatar(value){
            let avatar = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
            try {
                let rest = value % 26
                return " " + avatar[rest]; 
            } catch (error) {
                return " W"
            }
        },
        cookTitle(value){
            if(value && value.length > 16){
                return value.substring(0, 17) + "...";
            }
            return value;
        },
        cookImg(value){
            try {
               let index =  Math.ceil(Math.random()*210);
               let jpg = require("../assets/imgs/ming/clothing"+index+".jpg");
               return jpg;
            } catch (error) {
                let jpg = require("../assets/imgs/ming/clothing212.jpg")
                return jpg;
            }
            
        },
        cookTag(value) {
            try {
               let jpg = require("../assets/imgs/language/"+value);
               return jpg;
            } catch (error) {
                let jpg = require("../assets/imgs/language/leaf.png")
                return jpg;
            }
        }
    },
    data() {
        return {
            articlesData:[],
            blogList:[],
            page:1,
            length:1,
            pageNums:12,
            dataTotal:1,
            totalVisible:8,
            articlesList:[],
            ADMINCODE:CONFIG.ADMINCODE,
            SECRETARTICLES:CONFIG.SECRETARTICLES,
            relation:{
              'notes':'学习笔记',
              'solution':'解决方案',
              'collection':'转载',
              'secret':'个人随笔',
              'data-base':'db',
              'fontend':'fontend',
              'backend':'backend',
              'advance':'advance',
              'python':'python',
              'java':'java',
              'js':'js',
              'vue':'vue',
              'bigdata':'大数据',
              'deeplearn':'深度学习',
            },
            childrenRelation:{
                'shi-ci-ge-fu':'secret',
                'profession':'secret',
                'mysql':'db',
                'sqlite':'db',
                'mongodb':'db',
                'data-analysis':'advance',
                'c-language':'backend',
                'jquery':'fontend',
                'css':'fontend',
            },
            dialog:false,
            inputCode:"",
            currentPath:"",
            snackbar:false
        }
    },
    methods: {
        ...mapMutations(["setBlogPath"]),
        toBlogContent(item){
            let path = item.path;
            let names = path.split("/");
            let name = names[names.length-1];
            let _this = this;
            if (this.SECRETARTICLES.includes(name)){
                _this.inputCode = "";
                _this.currentPath = path;
                _this.dialog = true;
                return
            }else{
                _this.setBlogPath(path)
                _this.$router.push({path:"/blog/articles"});
            }
        },
        async getArticlesData(){
            let _this = this;
            let query = _this.$router.currentRoute.query;
            _this.page = 1;
            _this.length = 1;
            if(query){
                let type = query.type;
                _this.articlesData = [];
                let value = _this.relation[type];
                if(value){
                    let data = await import("@/config/articles/"+ type +".js");
                    _this.articlesData = data.NOTES;
                }else{
                    let parent = _this.childrenRelation[type];
                    if(parent){
                        let data = await import("@/config/articles/"+ parent +".js");
                        _this.articlesData = data.NOTES;
                    }
                }
                _this.dataTotal = _this.articlesData.length;
                _this.length = Math.ceil(_this.dataTotal/_this.pageNums);
                _this.getArticlesListData();
            }
        },
        getArticlesListData(){
            let _this = this;
            let pageNums = _this.pageNums;
            let minPage = pageNums*(_this.page - 1);
            let maxPage = pageNums*_this.page;
            maxPage = maxPage>_this.dataTotal?_this.dataTotal:maxPage;
            _this.articlesList = [];
            for(let i = minPage; i < maxPage; i++){
                _this.articlesList.push(_this.articlesData[i])
            }
        },
        showSercetArticle(){
            let _this = this;
            let code = _this.inputCode + "ye";
            if( code === _this.ADMINCODE){
                _this.dialog = false;
                _this.setBlogPath(_this.currentPath)
                this.$router.push({path:"/blog/articles"});
            }else{
                _this.dialog = false;
                _this.snackbar = true;
            }
        }
    },
    mounted() {
        let _this = this;
        _this.getArticlesData();
    },
    watch:{
        page(val){
            this.getArticlesListData();
        }
    }
}
</script>

<style lang="stylus" scoped>
.blogger-articles-container
  position absolute
  top  0
  bottom 0
  border 0
  left 0
  width  100%
  height  100%
  overflow  auto
  background-size  cover
  background-image url("../assets/imgs/bg/4.jpg")

.blog-col
    margin-top 20px

.blogger-articles-row
  margin-left 5%
  margin-top 32px

.blogger-card
  background-color #E0F7FA

.blog-title
  font-size 14px

.blog-subtitle
  font-size 10px

.avatar-text
  color  #E65100
  margin-left 32%

.blogger-card-action
    height 36px
    overflow  auto
    background-color inherit

.blogger-card-btn
    background-color inherit
    margin-right  5px
</style>